module.exports = "/_next/static/images/MaintenanceRestoration-8230ed0421db80a6e02a6cc7305e3df0.webp";